module.exports = __webpack_public_path__ + "img/a4-standard.2e247c72.png";